/** what a player can report someone for (the report dialog's buttons; the server keeps the name) */
export const ReportCategories = ["Aimbot", "Wallhack", "Teaming", "Other"] as const;
export type ReportCategory = typeof ReportCategories[number];

/** the details box: at most this many characters */
export const REPORT_TEXT_MAX = 300;

/** cleaned-up report text: no control characters, collapsed spaces, at most REPORT_TEXT_MAX characters */
export const cleanReportText = (text: unknown): string => typeof text === "string"
    ? text.replace(/[\u0000-\u001f\u007f]+/gu, " ").replace(/\s+/gu, " ").trim().slice(0, REPORT_TEXT_MAX)
    : "";
